export default "__VITE_ASSET__BeuXtR9O__"